module.exports = __webpack_public_path__ + "static/img/ali.344d281a.svg";